module.exports = __webpack_public_path__ + "static/media/blendmotion.791bfea2.png";